import { Fragment } from "react";
import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from "../../i18n/LanguageContext";

const listClasses = ["one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];

const content = {
    en: {
        title: "Privacy Policy",
        intro: "This privacy policy clarifies how personal data is processed, as the directory application website is committed to maintaining the confidentiality of sensitive data. -This policy has been prepared to disclose the application policy in data collection and dissemination.",
        sections: [
            {
                title: "Collection of Personal Information:",
                lines: [
                    "a. Tarqia will periodically receive and store personal information that you provide via our application, whether directly or in other forms.",
                    "b. Basic details such as your name, phone number, address, and email may be collected to send information, updates, and process orders. Additional information may be collected during feedback submission, change of content or email preferences, survey responses, financial data, or communication with customer support.",
                    "c. Any other information you provide during interactions with us may also be collected.",
                ],
            },
            {
                title: "How We Collect Personal Information:",
                lines: [
                    "a. Tarqia collects personal information through electronic and in-person interactions, application usage, and service provision. Information from third parties may also be received and will be protected as per this Privacy Policy.",
                ],
            },
            {
                title: "Use of Personal Information:",
                lines: [
                    "a. Personal information collected may be used to provide information, updates, and services. You may also be informed of new products, services, and opportunities. The information helps improve our offerings and understand your needs.",
                    "b. Third-party social media features may be offered through the application. The security of publicly shared social media information cannot be guaranteed. We may contact you via various channels, including phone, email, SMS, or mail.",
                ],
            },
            {
                title: "Disclosure of Personal Information:",
                lines: [
                    "a. Personal information may be disclosed to employees, officers, advisers, agents, or suppliers for the outlined purposes. Disclosure only occurs when necessary for service provision.",
                    "b. Legal requirements, such as court orders, legal proceedings, or law enforcement requests, may necessitate personal information disclosure.",
                    "c. Personal information may be used to safeguard copyright, trademarks, legal rights, or the safety of Tarqia, its application, website, customers, or third parties.",
                    "d. Information collected may be stored or processed in countries outside Australia.",
                    "e. During changes in business control, assets, or sales, user databases and personal information may be transferred under a confidentiality agreement.",
                ],
            },
            {
                title: "Security of Personal Information:",
                lines: [
                    "a. Tarqia ensures information security through physical, electronic, and managerial measures to protect against unauthorized access, disclosure, and misuse.",
                    "b. While measures are taken to protect information, transmission and exchange of data are at your risk. Security of transmitted information cannot be guaranteed.",
                ],
            },
            {
                title: "Complaints about Privacy:",
                lines: [
                    "a. Complaints can be submitted to our address. We take complaints seriously and respond promptly.",
                ],
            },
            {
                title: "Changes to Privacy Policy:",
                lines: [
                    "a. We reserve the right to modify this Privacy Policy. Changes will be effective immediately upon posting.",
                ],
            },
            {
                title: "Software Application:",
                lines: [
                    "a. Automatic collection: When using the application, certain information is collected. Cookies and automatic collection mechanisms are also utilized.",
                    "b. Third parties: The application may link to third-party websites; Tarqia is not responsible for their privacy practices.",
                    "c. Geo-Location: The application may use GPS technology to determine your location. Your location data will not be shared with other users or partners.",
                ],
            },
            {
                title: "Account Deletion",
                lines: [
                    "We value your privacy and believe in giving you full control over your personal information. If you no longer wish to use our Smart Digital Parking App and want to delete your account, we provide a straightforward process for you to do so.",
                    "To delete your account and all associated information, please follow these steps:",
                    "1- Open the Digital Parking Application: Launch the Smart Digital Parking App on your device.",
                    "2- Log in (if not already logged in): Enter your login credentials to access your account.",
                    "3- Navigate to the Settings Tab: Locate the Settings tab within the app's menu or navigation options.",
                    "4- Find the Delete Account Option: Within the Settings tab, you will find the option to delete your account.",
                    "5- Confirm Account Deletion: When you select the delete option, the app will prompt you to enter your password for confirmation.",
                    "6- Permanently Delete Your Account: Once you confirm the deletion by entering your password, your account and all associated information will be permanently deleted from our system.",
                ],
            },
        ],
    },
    ar: {
        title: "سياسة الخصوصية",
        intro: "توضح سياسة الخصوصية هذه كيفية معالجة البيانات الشخصية، إذ يلتزم موقع التطبيق بالحفاظ على سرية البيانات الحساسة. وقد أُعدّت هذه السياسة للإفصاح عن سياسة التطبيق في جمع البيانات ونشرها.",
        sections: [
            {
                title: "جمع المعلومات الشخصية:",
                lines: [
                    "أ. تتلقى ترقية بشكل دوري المعلومات الشخصية التي تقدمها عبر تطبيقنا وتخزنها، سواء قدّمتها مباشرة أو بأشكال أخرى.",
                    "ب. قد نجمع بيانات أساسية مثل اسمك ورقم هاتفك وعنوانك وبريدك الإلكتروني لإرسال المعلومات والتحديثات ومعالجة الطلبات. وقد نجمع معلومات إضافية عند إرسال الملاحظات، أو تغيير تفضيلات المحتوى أو البريد الإلكتروني، أو الرد على الاستبيانات، أو البيانات المالية، أو التواصل مع دعم العملاء.",
                    "ج. قد نجمع أيضاً أي معلومات أخرى تقدمها خلال تعاملك معنا.",
                ],
            },
            {
                title: "كيف نجمع المعلومات الشخصية:",
                lines: [
                    "أ. تجمع ترقية المعلومات الشخصية من خلال التعاملات الإلكترونية والمباشرة، واستخدام التطبيق، وتقديم الخدمات. وقد نتلقى معلومات من أطراف ثالثة، وتُحمى وفقاً لسياسة الخصوصية هذه.",
                ],
            },
            {
                title: "استخدام المعلومات الشخصية:",
                lines: [
                    "أ. قد تُستخدم المعلومات الشخصية التي نجمعها لتقديم المعلومات والتحديثات والخدمات، وقد نُعلمك بالمنتجات والخدمات والفرص الجديدة. وتساعدنا هذه المعلومات على تحسين ما نقدمه وفهم احتياجاتك.",
                    "ب. قد يوفر التطبيق ميزات لوسائل تواصل اجتماعي تابعة لأطراف ثالثة، ولا يمكن ضمان أمان المعلومات المنشورة علناً على وسائل التواصل الاجتماعي. وقد نتواصل معك عبر قنوات مختلفة، منها الهاتف والبريد الإلكتروني والرسائل النصية والبريد العادي.",
                ],
            },
            {
                title: "الإفصاح عن المعلومات الشخصية:",
                lines: [
                    "أ. قد نفصح عن المعلومات الشخصية للموظفين أو المسؤولين أو المستشارين أو الوكلاء أو الموردين للأغراض الموضحة، ولا يتم الإفصاح إلا عند الضرورة لتقديم الخدمة.",
                    "ب. قد تستدعي المتطلبات القانونية، مثل أوامر المحاكم أو الإجراءات القانونية أو طلبات جهات إنفاذ القانون، الإفصاح عن المعلومات الشخصية.",
                    "ج. قد تُستخدم المعلومات الشخصية لحماية حقوق النشر أو العلامات التجارية أو الحقوق القانونية أو سلامة ترقية وتطبيقها وموقعها الإلكتروني وعملائها أو الأطراف الثالثة.",
                    "د. قد تُخزَّن المعلومات التي نجمعها أو تُعالَج في دول خارج أستراليا.",
                    "هـ. في حال حدوث تغييرات في السيطرة على الأعمال أو الأصول أو عمليات البيع، قد تُنقل قواعد بيانات المستخدمين والمعلومات الشخصية بموجب اتفاقية سرية.",
                ],
            },
            {
                title: "أمن المعلومات الشخصية:",
                lines: [
                    "أ. تضمن ترقية أمن المعلومات من خلال إجراءات مادية وإلكترونية وإدارية للحماية من الوصول أو الإفصاح أو الاستخدام غير المصرح به.",
                    "ب. رغم الإجراءات المتخذة لحماية المعلومات، فإن نقل البيانات وتبادلها يتم على مسؤوليتك، ولا يمكن ضمان أمن المعلومات المنقولة.",
                ],
            },
            {
                title: "الشكاوى المتعلقة بالخصوصية:",
                lines: [
                    "أ. يمكن تقديم الشكاوى إلى عنواننا، ونحن نأخذ الشكاوى على محمل الجد ونرد عليها بسرعة.",
                ],
            },
            {
                title: "التغييرات على سياسة الخصوصية:",
                lines: [
                    "أ. نحتفظ بحق تعديل سياسة الخصوصية هذه، وتصبح التغييرات سارية فور نشرها.",
                ],
            },
            {
                title: "تطبيق البرمجيات:",
                lines: [
                    "أ. الجمع التلقائي: عند استخدام التطبيق يتم جمع بعض المعلومات، كما نستخدم ملفات تعريف الارتباط وآليات الجمع التلقائي.",
                    "ب. الأطراف الثالثة: قد يحتوي التطبيق على روابط لمواقع أطراف ثالثة، ولا تتحمل ترقية مسؤولية ممارسات الخصوصية الخاصة بها.",
                    "ج. الموقع الجغرافي: قد يستخدم التطبيق تقنية GPS لتحديد موقعك، ولن تُشارك بيانات موقعك مع مستخدمين أو شركاء آخرين.",
                ],
            },
            {
                title: "حذف الحساب",
                lines: [
                    "نحن نقدّر خصوصيتك ونؤمن بمنحك تحكماً كاملاً في معلوماتك الشخصية. إذا لم تعد ترغب في استخدام تطبيق المواقف الرقمية الذكي وأردت حذف حسابك، فإننا نوفر لك طريقة سهلة لذلك.",
                    "لحذف حسابك وجميع المعلومات المرتبطة به، يُرجى اتباع الخطوات التالية:",
                    "1- افتح تطبيق المواقف الرقمية: شغّل تطبيق المواقف الرقمية الذكي على جهازك.",
                    "2- سجّل الدخول (إن لم تكن مسجلاً): أدخل بيانات الدخول للوصول إلى حسابك.",
                    "3- انتقل إلى تبويب الإعدادات: ابحث عن تبويب الإعدادات في قائمة التطبيق أو خيارات التنقل.",
                    "4- ابحث عن خيار حذف الحساب: ستجد خيار حذف حسابك داخل تبويب الإعدادات.",
                    "5- أكّد حذف الحساب: عند اختيار الحذف، سيطلب منك التطبيق إدخال كلمة المرور للتأكيد.",
                    "6- احذف حسابك نهائياً: بمجرد تأكيد الحذف بإدخال كلمة المرور، سيُحذف حسابك وجميع المعلومات المرتبطة به نهائياً من نظامنا.",
                ],
            },
        ],
    },
};

const PrivacyPolicy = () => {
    const { lang } = useLanguage();
    const c = content[lang];
    return (
        <>
            <Container maxWidth="lg" align="center" className="eParkingSection privacypolicySection" id="privacypolicySection">
                <Typography variant="h3" gutterBottom >
                    {c.title}
                </Typography>
                <Box className="EParkingContent">
                    <Typography variant="subtitle1" gutterBottom >
                        {c.intro}
                    </Typography>
                    <Box className="eParkingList">
                        {c.sections.map((section, index) => (
                            <Box className="listContainer" key={index}>
                                <Typography variant="subtitle1" className={listClasses[index]} >
                                    <span>
                                        {section.title}
                                        {section.lines.map((line, lineIndex) => (
                                            <Fragment key={lineIndex}><br />{line}</Fragment>
                                        ))}
                                    </span>
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Container>
        </>
    )
}
export default PrivacyPolicy;
